/* Redactor Vue Component Version 1.1 Updated: March 25, 2020 http://imperavi.com/redactor/ Copyright 2020, Imperavi Ltd. License: MIT */
<template>
    <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" />
</template>

<script>
import Vue from 'vue';

import '../../redactor/redactor.min.js';
import '../../redactor/redactor.min.css';

export default {
    name: 'Redactor',

    redactor: false,
    props: {
        value: {
            default: '',
            type: String,
        },
        placeholder: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        config: {
            default: function () {
                return {
                    buttons: [/*'format',*/ 'bold', 'italic', 'link'],
                    //formatting: ['p', 'h2', 'h3'],
                };
            },
            type: Object,
        },
    },
    watch: {
        value(newValue) {
            if (!this.redactor.editor.isFocus()) this.redactor.source.setCode(newValue);
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.destroy();
    },
    methods: {
        init() {
            var me = this;
            var callbacks = {
                changed: function (html) {
                    me.handleInput(html);
                    return html;
                },
            };

            // extend config
            if (typeof this.config.callbacks === 'undefined') {
                Vue.set(this.config, 'callbacks', callbacks);
            } else {
                this.config.callbacks.changed = callbacks.changed;
            }

            // call Redactor
            /*eslint no-undef: "off"*/
            var app = Redactor(this.$refs.redactor, this.config);

            // set instance
            this.redactor = app;
            this.$parent.redactor = app;
        },
        destroy() {
            // Call destroy on redactor to cleanup event handlers
            Redactor(this.$refs.redactor, 'destroy');

            // unset instance for garbage collection
            this.redactor = null;
            this.$parent.redactor = null;
        },
        handleInput(val) {
            this.$emit('input', val);
        },
    },
};
</script>
<styles lang="scss">
.redactor-box {
    .redactor-styles {
        font-family: 'Roboto', sans-serif;
        font-size: 16px;
    }
}
</styles>
